import React from "react";
import BlogSocial from './BlogSocial';

const BlogContent = () => {
  return (
    <>
      <div className="my-10">
        {/* Image */}
        <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/23-696x464.jpg" />

        {/* Blog Social */}
        <BlogSocial />

        {/* Text */}
        <div className="text-sm mt-10 mb-5 px-3 md:px-12">
          We woke reasonably late following the feast and free flowing wine the
          night before. After gathering ourselves and our packs, we headed down
          to our homestay family’s small dining room for breakfast.
        </div>

        {/* Image */}
        <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/girl2.jpg" />

        {/* Text */}
        <div className="text-sm mt-10 mb-5 px-3 md:px-12">
          We woke reasonably late following the feast and free flowing wine the
          night before. After gathering ourselves and our packs, we headed down
          to our homestay family’s small dining room for breakfast.
        </div>

        {/* Quote */}
        <div className="text-center text-xl md:text-3xl italic px-3 md:px-24">
          IF YOU HAVE IT, YOU CAN MAKE ANYTHING LOOK GOOD
        </div>

        {/* Text */}
        <div className="text-sm mt-10 mb-5 px-3 md:px-12">
          We woke reasonably late following the feast and free flowing wine the
          night before. After gathering ourselves and our packs, we headed down
          to our homestay family’s small dining room for breakfast.
        </div>

        {/* Quote */}
        <div className="text-center text-xl md:text-3xl italic px-3 md:px-24">
          IF YOU HAVE IT, YOU CAN MAKE ANYTHING LOOK GOOD
        </div>

        {/* Text */}
        <div className="text-sm mt-10 mb-5 px-3 md:px-12">
          We woke reasonably late following the feast and free flowing wine the
          night before. After gathering ourselves and our packs, we headed down
          to our homestay family’s small dining room for breakfast.
        </div>


      </div>

      <BlogSocial />
    </>
  );
};

export default BlogContent;
